import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Frame, Image, QcropModel, UiTemplate } from '../../model/qcrop.model';
import { FocalPoint } from '../../features/focal-point/model/focal-point.model';

export const qcropActions = createActionGroup({
  source: 'qcrop',
  events: {
    'Init Qcrop': props<{ assetId: string }>(),
    'Init Qcrop success': emptyProps(),
    'Init Qcrop failed': props<{ error: any }>(),
    'Set Active AssetId': props<{ assetId: string }>(),
    'Set Image': props<{ image: Image }>(),
    'Get Qcrop': emptyProps(),
    'Load Qcrop': props<{ assetId: string }>(),
    'Load Qcrop Success': props<{ qcrop: QcropModel }>(),
    'Load Qcrop failed': props<{ error: any }>(),
    'Save Qcrop': emptyProps(),
    'Save Qcrop success': props<{
      qcrop: QcropModel;
      request: QcropModel | null;
    }>(),
    'Save Qcrop failed': props<{ error: any }>(),
    'Set _qcrop': props<{ qcrop: QcropModel }>(),
    'Modify UiTemplate': props<{ uiTemplate: UiTemplate; index: number }>(),
    'Toggle visibility all UiTemplates': props<{ visible: boolean }>(),
    'Toggle visibility all FocalPoints': props<{ visible: boolean }>(),
    'Reload _qcrop': emptyProps(),
    'Modify FocalPoint': props<{
      focalPoint: FocalPoint;
      index: number;
    }>(),
    'Add FocalPoint': props<{ focalPoint: FocalPoint }>(),
    'Remove FocalPoint': props<{ index: number }>(),
    'Set active FocalPoint': props<{ focalPoint: FocalPoint; index: number }>(),
    'Set active Frame': props<{ uiTemplate: UiTemplate; index: number }>(),
    'Auto Generate Frames': props<{ templateIds: string[] }>(),
    'Auto Generate Frames Success': props<{ frames: Frame[] }>(),
    'Auto Generate Frame failed': props<{ error: any }>(),
    'Set token': props<{ token: string | null }>(),
    'set CompanyId': props<{ companyId: string | null }>(),
  },
});
